module.exports = __webpack_public_path__ + "static/media/catalogueImg3.738306b2.png";